<template>
  <div
    :class="{dark: isDark}"
    class="total-time"
  >{{ duration }}</div>
</template>

<script>
import Store from '../store'
import Time from '../helpers/Time'

export default {
  data () {
    return {
      store: Store
    }
  },
  computed: {
    duration () {
      return Time.iso(this.store.state.duration)
    },
    isDark () { return this.store.state.isDark }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.total-time {
  background: $white-trans-600;
  border-radius: 2px;
  height: 16px;
  margin: -8px 8px 0 0;
  padding: 0 5px;
  top: 50%;
  position: absolute;
  right: 0;
  z-index: 4;

  @include font-xs();

  font-size: .6428rem;

  &.dark {
    background: $black-trans-600;
    color: $white-trans-700;
  }
}
</style>
